<app-nav-menu></app-nav-menu>
@if (airarabialoader) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top: -70px; ">
    <div class="loaderforPassenger">
      Loading
      <span class="loadspan"></span>
    </div>
  </div>
}
@if (userService.showSpinner|async) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top: -70px; ">
    <div class="loaderforPassenger_forBooking">
      <span class="message">Booking In Process</span>
      <span class="loadspan"></span>
    </div>
  </div>
}
<div id="errormessage" class="custom_eroor">
  <div class="custom-modal">
    <div class="danger danger-animation icon-top"><i class="fas fa-times"></i></div>
    <div class="danger border-bottom"></div>
    <div class="content">
      @if (mealerror) {
        <p class="type">MEAL</p>
      }
      @if (baggageerror) {
        <p class="type">BAGGAGE</p>
      }
      <p class="message-type">Not Availiable.</p>
    </div>
  </div>
</div>

<main class="col-sm-12 main container">

  <div>
    <ng-template #issueticket let-modal>

      <div class="modal-success ">
        <img class="sucesspopup" src="assets/img/icons8-error.gif" />

        <p class="textpopupsuccess"> Are You Sure?</p>
        <p class="innerhtmlofmodal"> You Want To Issue Ticket?</p>
        <div class="marginbtnlft">
          <div>
            <button class="yesButton" [disabled]="buttonagreed" (click)="onSubmit()">Yes, issue it!</button>
          </div>
          <div>
            <button class="noButton" (click)="modal.dismiss()">No</button>
          </div>
        </div>
      </div>


    </ng-template>
  </div>
  <div>
    <ng-template #sweet let-modal>

      <div class="modal-success">
        <img class="sucesspopup" src="assets/img/newsuccess.gif" />

        <h2 class="textpopupsuccess"> Passenger Data Saved!</h2>
        <button class="okButton" (click)="modal.dismiss()">Ok</button>
      </div>


    </ng-template>
  </div>

  <!--bad-->
  <div>
    <ng-template #bad let-modal>

      <div class="modal-success">
        <img class="sucesspopup" src="assets/img/badicon.gif" />

        <h2 class="textpopupbad"> Not Saved!</h2>
        <h5 class="textsubheadpopup"> Please Try Again!</h5>
        <button class="okButton" (click)="modal.dismiss()">Ok</button>

      </div>


    </ng-template>
  </div>

  <div class="header-bg">
    <div class="d-flex">

      <div class="address_logo col-sm-2">
        @if (bookingBaseData.flightProp.tripType != 'multi') {
          <img class="flight_logo_main" src="assets/img/{{bookingBaseData.flightscheduleNew.departureFlight.airlineLogo}}" alt="airline logo" />
        }
        @if (bookingBaseData.flightProp.tripType == 'multi') {
          <img class="flight_logo_main" src="assets/img/{{bookingBaseData.flightscheduleNew.multiFlights[0].airlineLogo}}" alt="airline logo" />
        }
      </div>
      <div class="main_head col-sm-10">
        @for (item of bookingBaseData.airSegment; track item) {
          <div class="for_detail d-flex">
            <div class="for_head">{{item.origin.code}}</div>
            <i class="uil uil-arrow-right for_head-icon"></i>
            <div class="for_head">{{item.destination.code}}</div>
          </div>
        }
        <div class="icon_head">
          <i class="uil uil-angle-right-b "></i>
        </div>
        <!--<div class="trip_review">-->
        <a (click)="open(mymodal)" style="cursor:pointer;text-decoration:underline" class="trip_review">Review Your Trip</a>
      <!--</div>-->
    </div>

  </div>
  <div class="change_link">
    <a (click)="back()" class="change_class-link">Back To Search Result</a>
  </div>
</div>

<div class="content_container">

  <div class="col-sm-3 right_side right_side_container">

    <div class="noti col-sm-12 price_summary">
      @if (showServiceCharges) {
        <div class="row m-0 p-1" style="width: 100%; display: flex; justify-content: center; align-items: center; ">
          <label style="color:black;font-size:12px;font-weight:bold">Service Charges Per Passenger</label>
          <div class="searchbox-wrap">
            <input type="number" placeholder="Markup" [(ngModel)]="serviceChargesPNR">
            <button (click)="ApplyServiceCharges()"><span>Apply</span> </button>
          </div>
        </div>
      }
    </div>
    <div class="noti col-sm-12 price_summary">

      <h4 style="margin-bottom:20px">
        Price Summary
      </h4>


      @for (price of priceCardDetails; track price) {
        <div>
          <div class="d-flex justify-content-between align-items-center price_summary_children_type"><label>{{price.passengerType}} @if (price.passengerCount > 1) {
            <span>x {{price.passengerCount}}</span>
          }</label></div>
          <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.indivisualBasePrice}}</span></div>-->
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Base Price</label><span>{{price.agencyBasePrice}}</span></div>
          <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.indivisualTaxes}}</span></div>-->
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Taxes & Other charges</label><span>{{price.agencyTaxes}}</span></div>
          <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.serviceFee}}</span></div>-->
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Service Fee</label><span>{{price.agencyServiceFee}}</span></div>
          <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.discount}}</span></div>-->
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Discount</label><span>{{price.agencyDiscount}}</span></div>
          <!--<div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.indivisualTotalPrice}}</span></div>-->
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Seat Fee</label><span>{{price.seatFee}}</span></div>
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Meal Fee</label><span>{{price.mealFee}}</span></div>
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Baggage Fee</label><span>{{price.baggageFee}}</span></div>
          <div class="d-flex justify-content-between align-items-center price_summary_children"><label>Total Price</label><span>{{price.agencyTotalPrice}}</span></div>
          <hr style="margin-top:20px" />
        </div>
      }
      <div class="d-flex justify-content-between align-items-center price_summary_children"><label class="price_total_label">Total Base Price</label><span class="price_total_tag">{{totalBasePriceConv}}</span></div>

      <div class="d-flex justify-content-between align-items-center price_summary_children">

        <label class="price_total_label">Total Taxes</label><span class="price_total_tag">{{totalTaxesConv}}</span>

      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">

        <label class="price_total_label">Total Discount</label><span class="price_total_tag">{{totalDiscountConv}}</span>

      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">

        <label class="price_total_label">Total ServiceFee</label><span class="price_total_tag">{{totalServiceFeeConv}}</span>

      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">

        <label class="price_total_label">Total ANCI Fee</label><span class="price_total_tag">{{totalANCIConv}}</span>

      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">

        <label class="price_total_label" style="font-weight: 800;font-size:12.5px">Trip Total</label><span class="price_total_tag" style="font-weight:800;font-size:12.5px">{{totalPriceConv}}</span>

      </div>

      <div style=" padding: 8px; border-top: 1px solid #e5d8d8;">
        <div style=" text-align: center; color: #ffaa00;"><p>Modified Balance</p></div>
        <div class="modify-body">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <p>Total Cost</p>
            <p>{{totalCostModified}}</p>
          </div>
          <div style=" display: flex; align-items: center; justify-content: space-between; font-weight: 700;">
            <p>Balance Due</p>
            <p>{{balanceDue.toFixed(2)}}</p>
          </div>
          <!--<div style=" display: flex; align-items: center; justify-content: space-between; font-weight: 700;">
          <p>Amount Due:</p>
          <p>{{AmountPaid.toFixed(2)}}</p>
        </div>-->
      </div>
    </div>

  </div>
</div>

<div>


  <form class="noti col-sm-9 form-line-active">
    <div class="form_title">Passenger Information</div>
    <div class="que_travel">Who's Traveling?</div>
    <!--<div class="travel_que-desc">Travelers name must match govt-issued photo ID exactly</div>-->

    @for (obj of bookingObj.bookingPassengerInfoProperties; track obj; let i = $index) {
      <div class="forms_container_main infant_type">
        <div class="main_form">
          <div class="row py-2 m-0">
            <div class="col-md-4 py-2 px-1">
              @if (obj.passengerType == 1) {
                <div class="detail_title" id="ptype{{i}}">Adult:</div>
              }
              @if (obj.passengerType == 2) {
                <div class="detail_title">Child:</div>
              }
              @if (obj.passengerType == 3) {
                <div class="detail_title">Infant:</div>
              }
              @if (obj.passengerType == 1) {
                <span class="detail_sub-title">12 years or Above</span>
              }
              @if (obj.passengerType == 2) {
                <span class="detail_sub-title">Less than 12 years</span>
              }
              @if (obj.passengerType == 3) {
                <span class="detail_sub-title">Less than 2 years</span>
              }
            </div>
          </div>
          @if (bookingObj.providerCode == 'SG') {
            <div class="sg-name">{{obj.firstName + " "+obj.lastName}}</div>
          }
          <!--------------------------------------------------------------------------------------- Aljazeera ends --------------- -->
          <!-------------------------------------------------------------------------- spice start----------------------- -->
          @if (SpiceAnxi  && obj.passengerType != 3) {
            <div>
              <div>
                <p class="exta-desc">Extra Services</p>
                @for (sector of obj.sectorInformationProperties; track sector; let f = $index) {
                  <div class="anci_section_FZ">
                    <div class="row">
                      <span class="sectorname">{{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:4px;margin-left:4px;color:black"></i> {{sector.toAirport}}</span>
                    </div>
                    <div class="anci_Section_columns">
                      <div class="anci_columns_head">
                        <div class="anci_columns_subhead">
                          <span class="anci_column_subject">Meal</span>
                          <span class="anci_column_name">{{sector.mealname}}</span>
                        </div>
                        <!-- *ngIf="SpiceDirect" -->
                        <div style=" width: 10%">
                          @if (sector.mealbtn) {
                            <button class="anci_column_edit" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>
                          }
                          <!--<button class="anci_column_edit" *ngIf="SpiceViaT && (f==0 || f==2)" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>
                          <button class="anci_column_edit" *ngIf="SpiceConnecting && (f==0 || f==2)" (click)="SpiceMealClick(i,f,poperrornot)"><i class="fas fa-edit"></i></button>-->
                          <!--popup of meal-->
                          <div id="mealpopup{{i}}{{f}}" class="numofseatmodel">
                            <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                              <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                                <div class="modal-content" style="width:100% !important">
                                  <div class="modal-header">
                                    <div class="seat_model_header">
                                      <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Meal Selection</span>
                                      <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="mealclose(i,f)" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="modal-body" style="padding: 0px !important;">
                                    <div style="width:100%;">
                                      <div style="width: 100%; padding: 6px;">
                                        <div class="mt-2 seat_info">
                                          <span class="seat_info_header" style="background-color: #39454B;">
                                            {{sector.fromAirport}} <i class="fas fa-plane-arrivals" style="margin-right:8px;margin-left:8px;color:white"></i> {{sector.toAirport}}
                                          </span>
                                          <div class="row">
                                            <div style="width:30%">
                                              <span class="seat_info_one_head ">
                                                Passenger Name:
                                              </span>
                                            </div>
                                            <div style="width:70%">
                                              <span class="seat_info_one">
                                                {{obj.title}} {{obj.firstName}} {{obj.lastName}}
                                              </span>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div style="width:30%">
                                              <span class="seat_info_one_head ">
                                                Meal Name:
                                              </span>
                                            </div>
                                            <div style="width: 70%; ">
                                              <span class="seat_info_one">
                                                {{sector.mealname}}
                                              </span>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div style="width:30%">
                                              <span class="seat_info_one_head ">
                                                Meal Charges:
                                              </span>
                                            </div>
                                            <div style="width:70%">
                                              @if (bookingBaseData.supplierCode == 'SG') {
                                                <span class="seat_info_one">
                                                  {{currency}} {{(sector.mealFee * currencyRate)| number: '1.1-2'}}
                                                </span>
                                              }
                                              <!--<span class="seat_info_one" *ngIf="bookingBaseData.supplierCode == 'J9'">
                                              {{currency}} {{(sector.mealFee)| number: '1.1-2'}}
                                            </span>-->
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style="width:100%;padding:6px;height:33rem;overflow:auto;">
                                      @for (mealsector of mealListJ; track mealsector; let m = $index) {
                                        <div class="meal_deatils_main">
                                          <div class="meal_Section">
                                            <div class="meal_section_one_image">
                                              <img style="height: 110px; width: 123px; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff;" src="../../assets/img/Oman_Air-Logo.wine.svg" />
                                            </div>
                                            <div class="meal_Section_deatils">
                                              <div class="meal_details_heading">
                                                <div class="meal_details_heading_section_one">
                                                  <!--.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail-->
                                                  <span style="font-weight:bold;font-size:18px;color:black;">{{mealsector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail}}</span>
                                                  <span style="font-size:12px;color:black;">
                                                    MEAL:{{mealsector.SSRCode}}
                                                  </span>
                                                </div>
                                                <div class="meal_details_heading_section_two" style="display:flex;justify-content:end">
                                                  <span style="font-weight:bold;font-size:21px;">{{currency}} {{(mealsector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount)}}</span>
                                                </div>
                                              </div>
                                              <div class="meal_deatils_button">
                                                <button class="meal_button_add" id="mealselectbtn{{i}}{{f}}{{m}}" (click)="spiceSelectMeal(i,f,m)"><span id="mealselectid{{i}}{{f}}{{m}}">Select</span></button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--end meal popup-->
                      </div>
                    </div>
                  </div>
                  <!--seat map of anci selectio -->
                  @if (this.bookingBaseData.supplierCode == 'SG' ) {
                    <div class="anci_Section_columns" style="margin-left:0.4%">
                      <div class="anci_columns_head">
                        <div class="anci_columns_subhead">
                          <span class="anci_column_subject">Seat</span>
                          <span class="anci_column_name">{{sector.seatNumber}}</span>
                        </div>
                        <div style=" width: 10%">
                          @if (sector.seatbtn) {
                            <button class="anci_column_edit" (click)="spiceSeatMapOpen(i,f)" id="seatselectid{{i}}{{f}}"><i class="fas fa-edit"></i></button>
                          }
                          <div id="newmodelofseat{{i}}{{f}}" class="SpiceSeatmodel">
                            <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                              <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="position: absolute; left: 250px;width:100%;">
                                <div class="modal-content" style="width:100% !important">
                                  <div class="modal-header">
                                    <div class="seat_model_header">
                                      <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Seat Selection</span>
                                      <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="SpiceSeatMapclose(i,f)" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="modal-body" style="padding: 0px !important;">
                                    <div class="seat_model_body_one">
                                      <div class="seat_model_body_two">
                                        <span class="seat_info_header">
                                          Seatmap Legend
                                        </span>
                                        <div class="row mb-2">
                                          <div class="col-md-3">
                                            <button class="square-skew " disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Available</span>
                                        </div>
                                      </div>
                                      <div class="row mb-2">
                                        <div class="col-md-3">
                                          <button class="square-skew_not not_avail_Seat" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Unavailable</span>
                                        </div>
                                      </div>
                                      <div class="row mb-2">
                                        <div class="col-md-3">
                                          <button class="square-skew" style="background-color:var(--first-color-second)" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Selected</span>
                                        </div>
                                      </div>
                                      <div class="row ">
                                        <div class="col-md-3">
                                          <button class="square-skew_not" style="background-color:orangered" disabled>
                                            <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                            <!--<span class="tooltip-text" id="top{{k}}{{q}}">I'm a tooltip!</span>-->
                                          </button>
                                        </div>
                                        <div class="col-md-9">
                                          <span>Seat Selected By Another Passenger</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="mt-2 seat_info">
                                      <span class="seat_info_header">
                                        Seat Information
                                      </span>
                                      <span class="seat_info_header_sector">
                                        {{sector.fromAirport}} To {{sector.toAirport}}
                                      </span>
                                      <div class="row">
                                        <div class="col-md-4">
                                          <span class="seat_info_one_head ">
                                            Name:
                                          </span>
                                        </div>
                                        <div class="col-md-8" style="overflow:hidden;display:flex">
                                          <span class="seat_info_one">
                                            {{obj.firstName}}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-4">
                                          <span class="seat_info_one_head ">
                                            Seat No:
                                          </span>
                                        </div>
                                        <div class="col-md-8">
                                          <span class="seat_info_one">
                                            {{sector.seatNumber}}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-7">
                                          <span class="seat_info_one_head ">
                                            Seat Charges:
                                          </span>
                                        </div>
                                        <div class="col-md-5">
                                          <span class="seat_info_one">
                                            {{currency}} {{((sector.seatFee * currencyRate)| number: '1.1-2')}}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="seat_mdl_bdy_airone">
                                    <div class="seat_mdl_bdy_airtwo">
                                      <div>
                                        <img class="seat_wing_one" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjg3LjY0LDM1Ny41OWE3LDcsMCwwLDEtNi44Myw3LjE3aDBhNyw3LDAsMCwxLTcuMTctNi44NGwtLjkxLTM4LjE2YTcsNywwLDAsMSw2LjgzLTcuMThoMGE3LDcsMCwwLDEsNy4xOCw2Ljg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMi4zMSAtMjIyLjY4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Mi41NCwzNDIuODhhNyw3LDAsMCwxLTYuODQsNy4xN2gwYTcsNywwLDAsMS03LjE3LTYuODRsLS45MS0zOC4xNmE3LDcsMCwwLDEsNi44NC03LjE4aDBhNyw3LDAsMCwxLDcuMTcsNi44NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOTcuNDMsMzI4LjE2YTcsNywwLDAsMS02Ljg0LDcuMThoMGE3LDcsMCwwLDEtNy4xOC02Ljg0bC0uOTEtMzguMTZhNyw3LDAsMCwxLDYuODUtNy4xOGgwYTcsNywwLDAsMSw3LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzA0Ljc3LDI0OC43OWwuNTQsMjIuODdhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTcsMTMuMTEtOS43OC0uNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU0LjMxLDIyMy4zMWwuNTQsMjIuODhhMTMuNzksMTMuNzksMCwwLDAsNi4wNywxMS4wOWw3LjY1LDUuMTYsMTMuMS05Ljc4LS43MS0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MjAuNzEsMjIyLjcxbDIsODUuMjItMzYuMjguODdMMjIyLjMxLDM1NS42OWMyLjg5LTIwLDIuMTUtMzIuMDcsMTUuMTUtMzguNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PC9zdmc+">
                                      </div>
                                      <div class="aircraft">
                                        <div class="aircraft-head">
                                          <!-- <div class="aircraft-head_inner"> -->
                                          <img style="width: 180px; padding-top: 32px;"
                                               src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTYuNDUgMTUzLjUzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjM1LjQsNzNzLTI5LjI3LDYuMTMtNDcuNjYsNDdMNTk4LDE0NS41M3MyMC40Mi0yOC45MywzNy40NC0yOC45M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0MC41MSw3M3Y0Mi41NWE2MC41Nyw2MC41NywwLDAsMSwzNy40NSwzMGwxMS4yMy0yNi4yMVM2NjMuNjYsNzIuMzQsNjQwLjUxLDczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTg1LjcsMTI1Ljc5bDkuODcsMjQuNTFTNTgyLDE3MS43NCw1NzkuOTEsMTg2LjM4bC0xMi41OS05Ljg3UzU3NS44MywxMzguMzgsNTg1LjcsMTI1Ljc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjkxLjIzLDEyNC4wOWwtOS44NywyNS4xOXMxMy4yOCwyMS43OCwxNiwzNy4xbDExLjkyLTEwLjg5UzcwMy40OSwxNDUsNjkxLjIzLDEyNC4wOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NjAuMzQgLTczLjAxKSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU2NS43OSwxODEuNzksNTc3LjUzLDE5MmwtNC45MywyOS40NXMtOS44OCwxMi4wOC0xMi4yNi0zLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjk5LjQsMTkxLjMybDExLjA3LTkuNTNzNi44MSwzMS4xNSw2LjMsMzcuNzhjMCwwLTMuMDcsMTUtMTIuNiwxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2MC4zNCAtNzMuMDEpIi8+PC9zdmc+">
                                            <!-- </div> -->
                                          </div>
                                          <div class="aircraft-body-exit-top">
                                            <div class="aircraft-body-exit-left-top">
                                            </div>
                                            <div class="aircraft-body-exit-top-center">
                                            </div>
                                            <div class="aircraft-body-exit-right-top">
                                            </div>
                                          </div>
                                          <div class="aircraft-body-exit">
                                            <div class="aircraft-body-exit-left">
                                              <div class="aircraft-inner-rowclass">
                                                <span>A</span>
                                                <span>B</span>
                                                <span>C</span>
                                              </div>
                                            </div>
                                            <div class="aircraft-body-exit-right">
                                              <div class="aircraft-inner-rowclass">
                                                <span>D</span>
                                                <span>E</span>
                                                <span>F</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="aircraft-body-exit-top">
                                            <div class="aircraft-body-exit-left-top">
                                            </div>
                                            <div class="aircraft-body-exit-top-center">
                                            </div>
                                            <div class="aircraft-body-exit-right-top">
                                            </div>
                                          </div>
                                          <div class="aircraft-body-rowClass">
                                            <div class="aircraft-row-innner-body">
                                              <div class="aircraft_inner_divoneJ">
                                                @for (seat of spiceSeats; track seat; let k = $index) {
                                                  <div class="aircraft_inner_divtwoJ">
                                                    <!-- seat.availability == '5' ||  *ngIf="seatobj.seatStatus == 'VAC' || *ngIf="seat.availability == '5' " -->
                                                    @if ((seat.SeatAvailability ==5) && (seat.Text == '')  ) {
                                                      <button class="square-skew hover-text" (click)="spiceSeatSelection(i,f,k)" id="link3button{{i}}{{f}}{{k}}">
                                                        <span style="width:10rem;" class="jtooltip-text" id="top{{k}}">
                                                          Charges:{{seat.Amount}}
                                                          Seat No:{{seat.SeatDesignator}}
                                                          <!--<p style="width:10rem;">Info:<span style="text-decoration:underline;" *ngFor="let prop of seat.properties">{{prop.code}}|</span></p>-->
                                                        </span>
                                                  <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                </button>
}
                                                @if (seat.SeatAvailability != 5) {
<button class="square-skew_not not_avail_Seat" disabled id="link3{{k}}">
                                                  <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                </button>
}
                                                @if (seat.Text == 'Occupied' && (seat.SeatAvailability > 0)  ) {
<button class="square-skew_not" style="background-color:orangered;cursor:not-allowed" disabled id="link3{{k}}">
                                                  <img class="imageofseats" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nO3ZO2gUQRzA4X8ERS0sDFpooZBCAlqIVj5QiKWNpBErRUEsBMEirQ/E2Ihob2GnhYUWaiXG3sZO0EJRLAQfpUE/OdiDcBzJTciMM5APhmvnx+7tzsxGrGoItuI8ZhaMM9getcNR/DDcb9zG2qgR1uGLpT2MGuGQ0U1HbXA4IeB51AbjCQG/sCZqg48JERNRGzxJCDgRtcG1hIArURtMJwQ8jtpgIiHgfdQGY4u8iQf9xaaoDeYSrsKBqA3uJgRciNrgbELA3MCqdalxrETAPvn8wWTugPWYbzagB28TJnUfsyOMG5iKEvCg9SXF5daXFFOtLynGm15S9OBTwpLi1gjvgIvYH6XgqTxeYWeJgOvy+YxtNe0NluNRTXuD5ZjvPSxy7w1+Zo44ki2gi3idOeB47oB7rQecaz1gsumAAv+DvZFbdxW+Z5j8h2LfGrAHb1Zw8l+Ln2h074WDuIQ73SKu72XCruwUNhed/JCY3mT6vmFLtAK7u+9lfaejJXgxcOuMRSuwsTsa0f3uipZgw0DAzcSTuZliJ3SLRDxr5oBrGOzAu2YDFtxKJ3F1xOf/7H85oVsVK+MfRwsah57JVgYAAAAASUVORK5CYII=" />
                                                </button>
}

                                                <!--</div>-->
                                              </div>
}
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                      <div>
                                        <img style="width: 207px; margin-left: -2px; margin-top: 163px;" src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAuNDMgMTQyLjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhMDt9LmNscy0ye2ZpbGw6IzAyMDAxNDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzU3LjQxLDM1Ny41OWE3LDcsMCwwLDAsNi44Myw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODMtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzAyLjUxLDM0Mi44OGE3LDcsMCwwLDAsNi44NCw3LjE3aDBhNyw3LDAsMCwwLDcuMTctNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODQtNy4xOGgwYTcsNywwLDAsMC03LjE3LDYuODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQ3LjYxLDMyOC4xNmE3LDcsMCwwLDAsNi44NSw3LjE4aDBhNyw3LDAsMCwwLDcuMTgtNi44NGwuOTEtMzguMTZhNyw3LDAsMCwwLTYuODUtNy4xOGgwYTcsNywwLDAsMC03LjE4LDYuODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzQwLjI4LDI0OC43OWwtLjU1LDIyLjg3YTEzLjc2LDEzLjc2LDAsMCwxLTYuMDYsMTEuMDlMMzI2LDI4Ny45MmwtMTMuMTEtOS43OC43Mi0zMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yOTAuNzQsMjIzLjMxbC0uNTQsMjIuODhhMTMuODIsMTMuODIsMCwwLDEtNi4wNywxMS4wOWwtNy42NSw1LjE2LTEzLjExLTkuNzguNzItMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIyLjMxIC0yMjIuNjgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjI0LjM0LDIyMi43MWwtMiw4NS4yMiwzNi4yOC44NywxNjQuMTUsNDYuODljLTIuODktMjAtMi4xNS0zMi4wNy0xNS4xNS0zOC43NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjIuMzEgLTIyMi42OCkiLz48L3N2Zz4=">
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
}
                  <!--End seat map of anci selection -->
                  <!--start of baggage anci selection -->
                  <div class="anci_Section_columns" style="margin-left:0.4%">
                    <div class="anci_columns_head">
                      <div class="anci_columns_subhead">
                        <span class="anci_column_subject">Baggage</span>
                        <span class="anci_column_name">{{sector.baggageCheckIn}}</span>
                      </div>
                      <div style=" width: 10%">
                        <!--airarabia-->
                        @if (bookingBaseData.supplierCode == 'SG') {
<div>
                          @if (sector.baggagebtn) {
<button class="anci_column_edit" (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>
}
                          <!--<button class="anci_column_edit" *ngIf="sector.baggagebtn && SpiceViaT && (f==0 || f==2)" (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>
                      <button class="anci_column_edit" *ngIf="sector.baggagebtn && SpiceConnecting " (click)="SpiceBaggageOpen(i,f)"><i class="fas fa-edit"></i></button>-->
                        </div>
}
                        <!--popup of baggage-->
                        <div id="baggagepopup{{i}}{{f}}" class="bagSpicemodel">
                          <div class="modal modal-lg" tabindex="-1" role="dialog" style="max-width: 100% !important; ">
                            <div class="modal-dialog modal-lg " role="document" style="position: absolute; left: 250px;width:100%;">
                              <div class="modal-content" style="width:100% !important">
                                <div class="modal-header">
                                  <div class="seat_model_header">
                                    <span style="font-size: 20px; color: white; font-weight: bold; letter-spacing: 2px; ">Baggage Selection</span>
                                    <button style=" position: absolute; right: 16px; color: white; opacity: 1;" type="button" class="close" (click)="baggageclose(i,f)" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>

                                <div class="modal-body" style="padding: 0px !important;">
                                  <div style="width:100%;display:flex;">
                                    <div style="width:30%;padding:6px;">
                                      <div class="mt-2 seat_info">
                                        <span class="seat_info_header">
                                          Baggage Information
                                        </span>
                                        <span class="seat_info_header_sector">
                                          {{sector.fromAirport}} To {{sector.toAirport}}
                                        </span>
                                        <div class="row">
                                          <div class="col-md-4">
                                            <span class="seat_info_one_head ">
                                              Name:
                                            </span>
                                          </div>
                                          <div class="col-md-8" style="overflow:hidden;display:flex">
                                            <span class="seat_info_one">
                                              {{obj.firstName}}
                                            </span>
                                          </div>

                                        </div>
                                        <div class="row">
                                          <div class="col-md-4">
                                            <span class="seat_info_one_head ">
                                              Baggage:
                                            </span>
                                          </div>
                                          <div class="col-md-8" style="overflow:hidden;display:flex">
                                            <span class="seat_info_one">
                                              {{sector.baggageCheckIn}}
                                            </span>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-8">
                                            <span class="seat_info_one_head ">
                                              Baggage Charges:
                                            </span>
                                          </div>
                                          <div class="col-md-4">
                                            @if (bookingBaseData.supplierCode == 'SG') {
<span class="seat_info_one">
                                              {{currency}} {{(sector.baggageFee * currencyRate)| number: '1.1-2'}}
                                            </span>
}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style="width:70%;padding:6px;">
                                      <div class="meal_deatils_main">
                                        <div class="baggage_container">
                                          <div style="display:flex;flex-direction:column;">
                                            <span style="color:var(--first-color-second);font-weight:bold;">Checked Baggage</span>
                                            <span style="color:black;margin-bottom:4px;">It maybe  cheaper to book sufficient baggage allowance now than paying excess fee at the airport.</span>

                                            <span style="color: black; font-weight: bold; margin-bottom: 8px;">Pick your preferred weight</span>


                                          </div>
                                          <div class="cards_of_bagage">
                                            @if (bookingBaseData.supplierCode == 'SG') {
<div class="row m-0 ">
                                              @for (baggagesector of baggageListJ; track baggagesector; let b = $index) {
<div class="col-sm-4  baggage_container" style="margin-bottom: 4px;">
                                                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                                  <span style="color:var(--first-color-second);font-size:50px">
                                                    <i class="fas fa-suitcase"></i>
                                                  </span>
                                                  <span class="bgag-name">
                                                    {{baggagesector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail}}({{baggagesector.SSRCode}})
                                                  </span>
                                                  <span style="color: var(--first-color-second); font-weight: bold; font-size: 14px; margin-bottom: 6px;">{{currency}} {{(baggagesector.PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount)| number: '1.1-2'}}</span>
                                                  <button class="meal_button_add" id="baggageselectbtn{{i}}{{f}}{{b}}" (click)="spiceBaggageSelect(i,f,b)"><span id="baggageselectid{{i}}{{f}}{{b}}">Select</span></button>
                                                </div>

                                              </div>
}

                                            </div>
}

                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        <!--end baggage popup-->
                      </div>

                    </div>
                  </div>
                </div>
}
              </div>
            </div>
}


            <!--------------------------------------------------------------------------------------- spice ends --------------- -->




          </div>
        </div>
}


        <div class="main_form">
          <div class="que_travel">Rules & Restrictions</div>
          <div class="que_line"></div>
          <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Kindely Check the spelling & reconfirm the passenger name(s) before you book.</div>
          <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Ticket name changes are not permitted once issued.</div>
          <h3 class="rules_desc">The above mentioned purchased tickets are non-transferable and name changes not permitted.</h3>
          <div class="rules_footer">
            <div class="checkBox">
              <input type="checkbox" [(ngModel)]="agreed" [ngModelOptions]="{standalone: true}" (change)="active()" />
              <div class="accept">I accept the Terms & Conditions.</div>
            </div>
            <!-- spinner -->
            <!--<div class="psngr-save">
          <div class="col-md-12 text-center">
            <div class="spinner-border text-primary" ></div>
          </div>
        </div>-->
            <div class="rules_buttons">
              <p-dialog [(visible)]="visibleWrongAgency" [modal]="true" [closable]="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">

                <p>
                  Fares has been Changed! Please search Again!.
                </p>
                <ng-template pTemplate="footer">
                  <button (click)="visibleWrongAgency =false" [routerLink]="['/flightSearch']" class="button-85">Back to Flight Search</button>
                </ng-template>
              </p-dialog>
              <button class="sendButton" [disabled]="buttonagreed" (click)="tktSuccuessPopup(issueticket)">Continue</button>
              <button class="cancelButton" (click)="cancel()">Cancel</button>
              <div id="response-screen" style="margin-top:15px;text-align:center;font-size:1.2rem;font-weight:bold"></div>
            </div>
          </div>
        </div>
      </form>


      <ng-template #mymodal let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">Flight Route</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" style="font-size:33px">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div class="noti col-sm-12 notification_area">
            @for (item of bookingBaseData.airSegment; track item; let i = $index) {
<div class="flight_details">
              @if (item.layoverAvailable) {
<div class="flight_schedule flight_time_frame connectionTime">Connection Time: {{item.layoverTime}}</div>
}

              <h4>{{item.origin.code}} To {{item.destination.code}}</h4>
              <div class="flight_schedule">{{item.carrier}} <span class="dot">|</span> RBD: {{item.classOfService}}</div>
              <div class="flight_screen">
                <div class="flight_details_children flight_details_children_flex">
                  <img src="assets/img/take-off-24.png">
                  <div>
                    <div class="flight_schedule_larger"> {{item.departureDate}}-{{item.departureTime}} -  {{item.origin.code}}</div>
                    <div class="flight_schedule" style="white-space:pre-wrap">Terminal:{{item.origin.terminal}}</div>
                    <div class="flight_schedule" style="white-space:pre-wrap">{{item.destination.airportName}}</div>
                  </div>
                </div>
                <div class="flight_details_children flight_details_children_slide_left">
                  <div class="flight_schedule flight_time_frame">{{item.flightTime}}</div>
                  <div class="flight_schedule flight_time_frame">{{item.carrier}}  {{item.flightNumber}}</div>

                </div>

                <div class="flight_details_children flight_details_children_flex" style="padding-left:15px">
                  <img src="assets/img/landing-24.png" />
                  <div>
                    <div class="flight_schedule_larger"> {{item.arrivalDate}}-{{item.arrivalTime}} -  {{item.destination.code}}</div>
                    <div class="flight_schedule" style="white-space:pre-wrap">Terminal:{{item.destination.terminal}}</div>
                    <div class="flight_schedule" style="white-space:pre-wrap">{{item.destination.airportName}}</div>
                  </div>
                </div>
              </div>

            </div>
}
          </div>

        </div>
      </ng-template>
    </div>

  </div>
</main>


